import {HTMLFormValidator} from '@mvps-genesis/form-validation';

export default class HTMLFormValidatorScrollTop extends HTMLFormValidator {

	isInViewport (element) {
		this.bounding = element.getBoundingClientRect();
		return (
			this.bounding.top >= 0 &&
			this.bounding.left >= 0 &&
			this.bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
			this.bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
		);
	};

	scrollToFirstError () {
		this.firstErroredElement = document.getElementsByClassName('has-error')[0];
		if (!this.isInViewport(this.firstErroredElement)) {
			this.bodyRect = document.body.getBoundingClientRect().top;
			this.firstErroredElementPosition = this.firstErroredElement.getBoundingClientRect().top - this.bodyRect;
			window.scrollTo({
				behavior: 'smooth',
				top: this.firstErroredElementPosition - 40
			});
		}
	}

	validateFormElement (element, event) {
		// Validate argument
		if (!element || element instanceof window.HTMLElement === false) {
			this.consoleError('validateFormElement requires a valid DOM element');
			return false;
		}
		// Only validate if element is visible
		if (element.offsetParent === null) {
			this.toggleError(element, 'hide');
			return true;
		}
		// Show or hide error based on validity
		if (element.validity.valid) {
			this.toggleError(element, 'hide');
			return true;
		}
		// If theres an element event, then only show the error when it has blurred
		if (!event || event.type === 'blur') {
			this.toggleError(element, 'show');
		}
		return false;
	};

	validateForm (event) {
		let bFormValid = true;
		const elemsLength = this.objGlobals.validatedElements.length;
		let index = 0;

		// Run custom validation first
		if (this.objGlobals.customValidationRef !== null) {
			bFormValid = this.objGlobals.customValidationRef();
		}
		// Validate each form element
		for (index = 0; index < elemsLength; index++) {
			if (!this.objGlobals.validatedElements[index].disabled) {
				if (!this.validateFormElement(this.objGlobals.validatedElements[index])) {
					bFormValid = false;
				}
			}
		}
		// Submit form if valid
		if (bFormValid) {
			// Run the pre-submit reference function if provided
			if (this.objGlobals.preSubmitRef !== null) {
				this.objGlobals.preSubmitRef();
			}
		} else {
			this.scrollToFirstError();
			event.preventDefault();
		}
	};
}
